(function loadAfroditeGardenWidget() {
  if (window.ztgWidgetConfig) return;

  var scriptSrc = 'https://ztgrowth.com.br/t/widget-loader.js';
  if (document.querySelector('script[src="' + scriptSrc + '"]')) return;

  window.ztgWidgetConfig = {
    companyHash: 'g65pe',
    apiBase: 'https://ztgrowth.com.br/',
    autoLoad: true
  };

  var script = document.createElement('script');
  script.src = scriptSrc;
  script.async = true;
  (document.head || document.body).appendChild(script);
})();
